export const FACILITY_TYPE_ALL = 'All Facilities';
